import get from './get'
import getOne from './get-one'
import getFoundersReport from './get-founders-report'
import getSeoReport from './get-seo-report'
import getMarketCapacityReport from './get-market-capacity-report'
import getMarketResultsReport from './get-market-results-report'
import create from './create'
import getStatistics from './get-statistics'
import getProjectFiles from './get-project-files'
import getProjectMembers from './get-project-members'
import getProjectCase from './get-project-case'
import getProjectBriefAnswers from './get-project-brief-answers'
import getProjectSearch from './get-project-search'
import getUserSearch from './get-user-search'
import updateProject from './update-project'
import updateProjectBriefAnswer from './update-project-brief-answer'
import uploadProjectFile from './upload-project-file'
import getMetrics from './get-metrics'
import createGrowthPointBasics from './create-growth-point-basics'
import getGrowthPoints from './get-growth-points'
import getUploadFileTypes from './get-upload-file-types'
import createUploadedFile from './create-uploaded-file'

const services = {
  get,
  create,
  getOne,
  getFoundersReport,
  getSeoReport,
  getMarketCapacityReport,
  getMarketResultsReport,
  updateProject,
  getStatistics,
  getProjectFiles,
  getProjectMembers,
  getProjectCase,
  getProjectBriefAnswers,
  getProjectSearch,
  getUserSearch,
  uploadProjectFile,
  updateProjectBriefAnswer,
  getMetrics,
  createGrowthPointBasics,
  getGrowthPoints,
  getUploadFileTypes,
  createUploadedFile,
}

export default services
